import { createSlice } from "@reduxjs/toolkit";

// Load persisted countries from localStorage
const loadPersistedCountries = () => {
  try {
    const saved = localStorage.getItem("globalCountries");
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error("Error loading persisted countries:", error);
    return [];
  }
};

// Save countries to localStorage
const persistCountries = (countries) => {
  try {
    localStorage.setItem("globalCountries", JSON.stringify(countries));
  } catch (error) {
    console.error("Error persisting countries:", error);
  }
};

const initialState = {
  globalCountries: loadPersistedCountries(), // Load from localStorage
};

const globalCountriesSlice = createSlice({
  name: "globalCountries",
  initialState,
  reducers: {
    setGlobalCountries: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.globalCountries = action.payload;
        // Persist to localStorage whenever countries change
        persistCountries(action.payload);
      } else {
        console.error("Payload must be an array");
      }
    },
  },
});

export const { setGlobalCountries } = globalCountriesSlice.actions;
export default globalCountriesSlice.reducer;
